<template>
  <div
    @click="isOpen = !isOpen"
    class="pin__box"
    :class="{ ' pin__box--open': isOpen }"
  >
    <div class="pin" :class="{ pin__open: isOpen }">
      <div class="pin__info">
        <span>{{ order.pins[0].name }}({{ order.pins[0].dongName }}) </span>
        <span>
          → {{ order.pins[order.pins.length - 1].name }}({{
            order.pins[order.pins.length - 1].dongName
          }})
        </span>
      </div>
      <div class="pin__price">
        <span>
          {{ order.deliveryOptions.totalOrderFee.toLocaleString() }}원
        </span>
        <img
          :class="{ 'pin__price--close': !isOpen }"
          src="@/assets/img/order/dropdown.svg"
        />
      </div>
    </div>
    <feeList v-if="isOpen" :deliveryOptions="order.deliveryOptions" />
  </div>
</template>
<script>
import feeList from "@/components/common/feeList.vue";
export default {
  components: { feeList },
  props: ["order"],
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>
<style src="./layout.css" scoped></style>
